// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1643":"294a497239f0438e","2806":"cd8073d1ab4e2b05"}[chunkId] + ".css";
};